import { FC } from 'react'
import { Global, css } from '@emotion/react'
import { global } from '@lifedot/styles/global'

const style = css(global)

export const GlobalStyle: FC = () => {
  return <Global styles={style} />
}
